module.exports = __webpack_public_path__ + "static/media/7.4cc63762.gif";